import * as Material from "@mui/material";
import { useTranslation } from "react-i18next";

import "./styles.css";

import { ReactComponent as BuildProductDraw } from "@assets/draws/product-creation.svg";
import AddIcon from "@mui/icons-material/Add";

import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import "react-image-crop/dist/ReactCrop.css";


import { Button } from '@fragments'

import { useCommunity } from "contexts/community";
import { ArrowForwardIosRounded, ShareRounded } from "@mui/icons-material";

import CommunityCard from "./CommunityCard";
import { Text } from "@fragments"
import AICircle from "@components/AICircle";

export default function Communities() {
  const { t } = useTranslation("community");

  document.title = t("communities.documentTitle");

  const { community } = useCommunity();

  window.communities = {};

  function handleOpenCreateNewCommunity() {
    community.management.open(null);
  }

  return (
    <main className="communities-screen pb-8">
      <div className="communities-side">
        <CommunityList />
      </div>
    </main>
  );
}

function CommunityList() {
  const { t } = useTranslation("community");
  const { loading, communities, community } = useCommunity();

  const NoCommunities = ({ }) => {
    return (
      <div className="no-communities-box px-4 py-1">
        <div className="ai-circle-block">
          <AICircle size={70} />
        </div>
        <Text.h3 className="mt-2">{t("communities.empty.title")}</Text.h3>
        <Text.h5 contrast={6} className="pb-2" style={{ width: '80%' }}>
          {t("communities.empty.subtitle")}
        </Text.h5>
        <Button
          variant="contained"
          color="inverse"
          onClick={() => window.open('https://builder.ginastee.com')}
          endIcon={<AddIcon />}
          children={t("communities.empty.createButton")}
        />
      </div>
    );
  };

  const communitiesDisplay = loading
    ? [{}, {}, {}, {}]
    : communities;


  return (<>
    <Text.h1 className="mt-5" weight={600}>{t("communities.listTitle")}</Text.h1>
    <div className="mt-3 communities-container">
      {communitiesDisplay.map((item, index) => (
        <CommunityCard data={item} key={index} />
      ))}
      {!loading && !communities?.length && <NoCommunities />}
    </div>
  </>
  );
}
